// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentType, type ComponentProps } from 'react';
import initial from 'lodash/initial';
import last from 'lodash/last';
import ReposIcon from '@atlaskit/icon/core/angle-brackets';
import LinkExternalIcon from '@atlaskit/icon/core/link-external';
import { BitbucketIcon } from '@atlaskit/logo';
import type { NavLink } from '@atlassian/jira-navigation-types/src/types.tsx';
import type { ShortcutItem } from '../types.tsx';

const getLinkParts = (linkId: string): string[] => linkId.split(':')[1].split('.');
// @ts-expect-error - TS7006 - Parameter 'props' implicitly has an 'any' type.
const SizedBitBucketIcon = (props) => <BitbucketIcon {...props} size="small" />;
// @ts-expect-error - TS7006 - Parameter 'props' implicitly has an 'any' type.
const RepoIcon = (props) => <ReposIcon {...props} spacing="spacious" />;
// @ts-expect-error - TS7006 - Parameter 'props' implicitly has an 'any' type.
const LinkIcon = (props) => <LinkExternalIcon {...props} spacing="spacious" />;

export const getIcon = (
	iconName?: string,
): ComponentType<
	JSX.LibraryManagedAttributes<
		typeof BitbucketIcon | typeof ReposIcon | typeof LinkExternalIcon,
		ComponentProps<typeof BitbucketIcon | typeof ReposIcon | typeof LinkExternalIcon>
	>
> => {
	switch (iconName) {
		case 'bitbucket':
			return SizedBitBucketIcon;
		case 'github':
		case 'repos':
			return RepoIcon;
		default:
			return LinkIcon;
	}
};

// @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
export const getIdFromLinkId = (linkId: string): string => last(getLinkParts(linkId));

export const getIdFromLinkIdV4 = (linkId: string): string => linkId;

export const getShortcutTypeFromLinkId = (linkId: string): string =>
	initial(getLinkParts(linkId)).join('.');

export const getItemFromLink = (link: NavLink): ShortcutItem => {
	const { id: linkId, icon } = link;
	const id = getIdFromLinkId(linkId);
	const shortcutType = getShortcutTypeFromLinkId(linkId);
	const target = link.target ?? '_blank';
	const Icon = getIcon(icon);

	return {
		id,
		icon,
		legacyId: linkId,
		target,
		shortcutType,
		text: link.name,
		before: Icon,
		href: link.url,
		canEdit: link.canEdit,
		showSync: link.showSync,
		itemType: 'shortcut',
	};
};
